// extracted by mini-css-extract-plugin
export default {"content":"styles_content__plqoK","message":"styles_message__G5VOy"};